import { UserProfile } from '../types/api';

/**
 * Check if user profile has all required fields filled
 * Required fields: first_name, last_name, company_name
 */
export const isProfileComplete = (profile: UserProfile | null): boolean => {
  if (!profile) {
    return false;
  }

  const hasFirstName = !!profile.first_name?.trim();
  const hasLastName = !!profile.last_name?.trim();
  const hasCompanyName = !!profile.company_name?.trim();

  return hasFirstName && hasLastName && hasCompanyName;
};

